import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-voucher-search',
  templateUrl: './voucher-search.component.html',
  styleUrls: ['./voucher-search.component.css']
})
export class VoucherSearchComponent implements OnInit {
  v:any={};
  data: any;
  branchlist: any=[];
  voucherReceiptlist: any=[];
  commonUrl : string ;
  scr_no_num:number;
  vouchergridlist: any=[];
  Ledgerlist: any=[];
  dis:string;

  constructor(private service: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private datepipe: DatePipe) {
    this.commonUrl = service.rootUrl;
   }

  ngOnInit() {
    this.GetAllBranches();
    this.GetLedgerDropdown();
  }

  //Branch dropdown
  GetAllBranches() {
    debugger;
      this.data = this.service.getAllBranches();
      this.data.subscribe(
        (response:any) => {
          this.branchlist = response;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

  GetVoucherReceiptNo(Transtype,TransDate,branchId){
    debugger;
      this.data = this.service.getVoucherReceiptNo(Transtype,TransDate,branchId);
      this.data.subscribe(
        (response:any) => {
          this.v.VoucherNo = response;
          console.log(response);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

  //dropdownlist
  GetReceiptNoDropdown(TransDate,Transtype,branchId){
    debugger;
    this.voucherReceiptlist =[];
      this.data = this.service.getReceiptNoDropdown(TransDate,Transtype,branchId);
      this.data.subscribe(
        (response:any) => {
          this.voucherReceiptlist = response.Result;
          console.log(this.voucherReceiptlist);
          for(let i=0;i<this.voucherReceiptlist.length;i++)
          {
            this.v.Amount=this.voucherReceiptlist[i].TRANS_AMT;
            this.v.Remarks=this.voucherReceiptlist[i].NARRATION;
            this.v.Acc_No =this.voucherReceiptlist[i].VOUCHER_NO;

            console.log( this.v.Remarks);
          }
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  GetReceiptNoDetails(receiptNo){
    debugger;
    console.log(receiptNo);

    //this.v.scr_no=receiptNo.slice(-4);
    
  
    for(let i=0;i<this.voucherReceiptlist.length;i++)
    {
      if(this.voucherReceiptlist[i].scr_no==receiptNo)
       {
            this.v.Amount=this.voucherReceiptlist[i].TRANS_AMT;
            this.v.Remarks=this.voucherReceiptlist[i].NARRATION;
            this.v.Acc_No =this.voucherReceiptlist[i].VOUCHER_NO;
            this.scr_no_num=this.voucherReceiptlist[i].SCR_NO_NUM;
            console.log( this.v.Remarks);
          }
    }
    this.GetVoucherGrid(this.scr_no_num,this.v.BRANCH_ID);//gridfunctioncall
    this.dis='Y';
  }

  //Report Printing
  // Print()
  // {
  //   console.log(this.v.Transtype);
    //debugger;
    // if(this.v.Transtype='P')
    // {
    //   window.open(this.commonUrl+'/Reports/Report.aspx?id=2');
    // }
  //   if(this.v.Transtype='R')
  //   {
  //    // window.open(this.commonUrl+'/Reports/Report.aspx?id=1');
  //     window.open(this.commonUrl+'/Reports/DatasetReports.aspx?id=2');
  //   }
  // }

  //Report Printing
  Print()
  {
    debugger;
    this.data = this.service.printvoucherHere(this.v.scr_no,this.v.TransType,this.scr_no_num,this.v.BRANCH_ID);
    this.data.subscribe(
      (response:any) => {
         let TransType = response;
         if(TransType='R'){
          window.open(this.commonUrl+'/Reports/DatasetReports.aspx?id=2');
         }
        console.log(response);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }


  GetVoucherGrid(scr_no_num,BRANCH_ID)
  {
    debugger;
      this.data = this.service.getVoucherGrid(scr_no_num,BRANCH_ID);
      this.data.subscribe(
        (response:any) => {
          this.vouchergridlist = response.Result;
          console.log(this.vouchergridlist);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });

  }

  //Ledger dropdown
  GetLedgerDropdown() {
    debugger;
      this.data = this.service.getLedgerDropdown();
      this.data.subscribe(
        (response:any) => {
          this.Ledgerlist = response.Result;
          console.log(this.Ledgerlist);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  NewAddfunction()
  {
    debugger;
    this.dis='N';
   
    // let temp = {
    //   LName: this.v.Ledger,
    //   TransAmt:this.v.Amount,
    //   AccNo: this.v.Acc_No,
    //   Remarks:this.v.Remarks
    // }
    // this.vouchergridlist.push(temp);
  }

 // Save
  SaveVoucherDetails(vouchersearch: NgForm) {
    debugger;
    //if (!customer_creation.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      // for (let i = 0; i < this.Documents.length; i++) {
      //   customer_creation.value.CERT_ID=this.Documents[i].CERT_ID;
      //   customer_creation.value.LINKNO=this.Documents[i].LINKNO;
      //   customer_creation.value.LINKDATE=this.Documents[i].LINKDATE;
      // }
      // customer_creation.value.DocumentModelsList= this.Documents;
      // customer_creation.value.CustomerType=this.c.CUSTTYPE;
      // console.log(customer_creation.value);
      vouchersearch.value.SCR_NO_NUM=this.scr_no_num;
      //vouchersearch.value.VoucherGridList=this.vouchergridlist;
      this.data = this.service.SaveVoucherDetails(vouchersearch.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Saved Successfully.', 'success');
          this.GetVoucherGrid(vouchersearch.value.SCR_NO_NUM,vouchersearch.value.BRANCH_ID);
          this.dis='Y';
          //vouchersearch.reset();
         // this.Documents=[];
         // this.router.navigate(['/home/UnicoreMaster']);
        }, (error) => {
         document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.handleError(error);
        });
    //}
    // else {
    //   document.getElementById('loader-spinner').style.display = "none";
    //   swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
    // }
  }


  //Delete
  DeleteVoucherList(vouchersearch: NgForm)
  {  
    debugger;
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        vouchersearch.value.SCR_NO_NUM=this.scr_no_num;
        vouchersearch.value.VoucherGridList=this.vouchergridlist;
        this.service.deleteVoucherList(vouchersearch.value).subscribe(
          (data:any) => {
            swal('','Upload Deleted!','success');
            //this.Uploads.splice(i, 1);
            document.getElementById('loader-spinner').style.display="none";
            //this.GetAllDistricts(this.itemsPerPage, 1);
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.handleError(error);
          });
      }
    })     
  } 
  


  ClearAll(vouchersearch){
    this.dis='N';
    vouchersearch.reset();
    this.vouchergridlist=[];
  }



  


}



// WEBPACK FOOTER //
// ./src/app/help/voucher-search/voucher-search.component.ts